import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';

class ComprobanteCancelacionStatus extends Component {
  get config() {
    const { status, cancelacion_comentario } = this.props;

    let variant = 'secondary';
    let icon = 'check';
    let text = cancelacion_comentario || 'Cancelado';

    switch (status) {
      case 0:
        variant = 'secondary';
        icon = 'clock';
        text = 'Solicitud aceptada';
        break;

      case 10:
        variant = 'secondary';
        icon = 'clock';
        text = 'En Proceso';
        break;

      case 1:
        variant = 'secondary';
        icon = 'clock';
        text = 'Cancelado';
        break;

      case -1:
        variant = 'secondary';
        icon = 'check';
        text = 'Rechazado';
        break;

      case 2:
        variant = 'secondary';
        icon = 'clock';
        text = 'No cancelable';
        break;

      case 3:
        variant = 'secondary';
        icon = 'clock';
        text = 'Error en la solicitud';
        break;

      case 4:
        variant = 'secondary';
        icon = 'clock';
        text = 'Dead';
        break;

      case undefined:
        variant = 'info';
        icon = 'clock';
        text = '...';
        break;

      default:
        break;
    }

    return {
      icon,
      variant,
      text,
    };
  }

  render() {
    const { variant, text } = this.config;

    return (
      <Badge
        pill
        variant={variant}
      >
        {text}
      </Badge>
    );
  }
}

export default ComprobanteCancelacionStatus;
